import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import * as XLSX from 'xlsx';

import {
  DataTable,
  toast,
  Button as DsButton,
  FilterSelect,
  Tag,
  Modal,
  criarCopiaDeColuna
} from '../../components/ds';
import visaoAPI from '../../api/visaoPessoas';

// Pedido de vale-alimentação e vale-refeição do mês (Visão de Pessoas ›
// Benefícios › Alimentação e refeição). Substitui a planilha
// Pedido_Refeicao_Alimentacao: cartão (Alelo, VR, iFood), tipo (A/R) e valor
// por dia vêm do cadastro; dias úteis e feriados são informados aqui uma vez
// para todos; férias, admissão no meio do mês e aviso indenizado já saem dos
// dias de cada um.
//
//   total = valor do dia x dias
//   profissional (4.1.5) = valor de 1 dia + 2ª via; estagiário não paga
//   empresa (2.1.3.2) = total - valor de 1 dia

const ROTULO_OPERADORA = { alelo: 'Alelo', vr: 'VR', ifood: 'iFood' };
const ROTULO_TIPO = { A: 'Alimentação', R: 'Refeição' };

const dinheiro = (v) =>
  v === null || v === undefined || v === ''
    ? '—'
    : Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const numero = (v) => (v === null || v === undefined || v === '' ? 0 : Number(v));

const rotuloCompetencia = (v) => {
  const [a, m] = String(v || '').split('-');
  return a && m ? `${m}/${a}` : '—';
};

const competenciasOferecidas = () => {
  const hoje = new Date();
  const lista = [];
  for (let d = -6; d <= 3; d++) {
    const x = new Date(hoje.getFullYear(), hoje.getMonth() + d, 1);
    lista.push(`${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}`);
  }
  return lista.reverse();
};

const competenciaPadrao = () => {
  const hoje = new Date();
  // Depois do dia 15 o pedido em preparo já é o do mês seguinte.
  const x = new Date(hoje.getFullYear(), hoje.getMonth() + (hoje.getDate() > 15 ? 1 : 0), 1);
  return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}`;
};

const ehVerdadeiro = (v) => v === true || v === 't' || v === 'true';

const lerNumero = (v) => {
  const t = String(v === null || v === undefined ? '' : v).trim();
  if (t === '') return null;
  const n = parseFloat(t.indexOf(',') >= 0 ? t.replace(/\./g, '').replace(',', '.') : t);
  return Number.isNaN(n) ? NaN : n;
};

const paraCampo = (v) =>
  Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Descrição do lançamento, igual à planilha do pedido.
const descricaoVA = (operadora, tipo) => {
  const t = (tipo || '').trim();
  if (operadora === 'ifood') return 'VALE ALMENTAÇÃO IFOOD';
  const cartao = operadora === 'vr' ? 'VR' : 'ALELO';
  return `${t === 'R' ? 'VALE REFEIÇÃO' : 'VALE ALIMENTAÇÃO'} ${cartao}`;
};

const mensagemErro = (e, padrao) => (e && e.response && e.response.message) || padrao;

const rotuloCartao = (op, tipo) => {
  const t = (tipo || '').trim();
  return `${ROTULO_OPERADORA[op] || op || '—'}${t ? ` ${t}` : op === 'ifood' ? ' A/R' : ''}`;
};

// Feriados digitados como dias do mês ("12, 28" ou "12/10") -> lista de
// 'AAAA-MM-DD'. Devolve { datas, erro }.
const lerFeriados = (texto, competencia) => {
  const [ano, mes] = competencia.split('-').map(Number);
  const ultimo = new Date(ano, mes, 0).getDate();
  const datas = [];
  const partes = String(texto || '').split(/[,;\s]+/).filter(Boolean);
  for (let i = 0; i < partes.length; i++) {
    const dia = parseInt(partes[i].split('/')[0], 10);
    if (!(dia >= 1 && dia <= ultimo)) return { datas: [], erro: `Feriado inválido: ${partes[i]}` };
    const iso = `${competencia}-${String(dia).padStart(2, '0')}`;
    if (datas.indexOf(iso) < 0) datas.push(iso);
  }
  return { datas: datas.sort(), erro: '' };
};

// Segunda a sexta do mês, fora os feriados.
const diasUteisDoMes = (competencia, feriadosIso) => {
  const [ano, mes] = competencia.split('-').map(Number);
  const ultimo = new Date(ano, mes, 0).getDate();
  let n = 0;
  for (let d = 1; d <= ultimo; d++) {
    const semana = new Date(ano, mes - 1, d).getDay();
    const iso = `${competencia}-${String(d).padStart(2, '0')}`;
    if (semana !== 0 && semana !== 6 && feriadosIso.indexOf(iso) < 0) n++;
  }
  return n;
};

class ValeAlimentacao extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      competencia: competenciaPadrao(),
      diasUteis: '',
      feriados: '',
      pedido: null,
      foraDoPedido: 0,
      itens: [],
      totais: {},
      porCartao: [],
      carregando: false,
      calculando: false,
      edicao: null,
      edDias: '',
      edSegunda: '',
      edObs: '',
      salvando: false
    };
    this.copia = criarCopiaDeColuna();
  }

  componentDidMount() {
    this.carregar();
  }

  carregar = () => {
    this.setState({ carregando: true });
    visaoAPI
      .getPedidoVA(this.state.competencia)
      .then((r) => {
        const pedido = r.pedido || null;
        const feriados = pedido && pedido.feriados
          ? pedido.feriados.split(',').map((d) => String(Number(d.slice(8, 10)))).join(', ')
          : '';
        this.setState({
          carregando: false,
          pedido,
          feriados,
          diasUteis: String(pedido ? pedido.dias_uteis : r.dias_uteis_sugeridos || ''),
          foraDoPedido: r.fora_do_pedido || 0,
          itens: r.request || [],
          totais: r.totais || {},
          porCartao: r.por_cartao || []
        });
      })
      .catch((e) => {
        this.setState({ carregando: false });
        toast.error(mensagemErro(e, 'Não foi possível carregar o pedido de alimentação e refeição.'));
      });
  };

  trocarCompetencia = (evento) => {
    this.setState({ competencia: evento.target.value }, this.carregar);
  };

  // Feriados mudam a sugestão de dias úteis; o campo continua editável.
  trocarFeriados = (evento) => {
    const texto = evento.target.value;
    const { datas, erro } = lerFeriados(texto, this.state.competencia);
    this.setState(
      erro ? { feriados: texto } : { feriados: texto, diasUteis: String(diasUteisDoMes(this.state.competencia, datas)) }
    );
  };

  calcular = () => {
    const dias = Number(this.state.diasUteis);
    if (!Number.isInteger(dias) || dias < 0 || dias > 31) {
      toast.error('Informe os dias úteis do mês (0 a 31).');
      return;
    }
    const { datas, erro } = lerFeriados(this.state.feriados, this.state.competencia);
    if (erro) {
      toast.error(erro);
      return;
    }
    this.setState({ calculando: true });
    visaoAPI
      .gerarPedidoVA(this.state.competencia, dias, datas)
      .then((r) => {
        this.setState({ calculando: false });
        toast.success(r.message || 'Pedido calculado.');
        this.carregar();
      })
      .catch((e) => {
        this.setState({ calculando: false });
        toast.error(mensagemErro(e, 'Não foi possível calcular o pedido.'));
      });
  };

  abrirEdicao = (linha) => {
    this.setState({
      edicao: linha,
      edDias: String(linha.dias_trabalhados),
      edSegunda: paraCampo(linha.valor_segunda_via),
      edObs: linha.observacao || ''
    });
  };

  fecharEdicao = () => this.setState({ edicao: null });

  salvarEdicao = () => {
    const { edicao: l, edDias, edSegunda, edObs } = this.state;
    const alt = {};
    const dias = Number(edDias);
    if (!Number.isInteger(dias) || dias < 0 || dias > 31) {
      toast.error('Dias de 0 a 31.');
      return;
    }
    if (dias !== Number(l.dias_trabalhados)) alt.dias_trabalhados = dias;
    const n = lerNumero(edSegunda);
    const segunda = n === null ? 0 : n;
    if (Number.isNaN(segunda) || segunda < 0) {
      toast.error('Valor da 2ª via inválido.');
      return;
    }
    if (Math.abs(segunda - numero(l.valor_segunda_via)) >= 0.005) alt.valor_segunda_via = segunda;
    if ((edObs || '') !== (l.observacao || '')) alt.observacao = edObs;

    if (Object.keys(alt).length === 0) {
      this.fecharEdicao();
      return;
    }
    this.enviarEdicao(l, alt);
  };

  recalcularLinha = () => this.enviarEdicao(this.state.edicao, { recalcular: true });

  enviarEdicao = (linha, alt) => {
    this.setState({ salvando: true });
    visaoAPI
      .editarItemVA(this.state.competencia, linha.cpf_funcionario, alt)
      .then(() => {
        this.setState({ salvando: false, edicao: null });
        this.carregar();
      })
      .catch((e) => {
        this.setState({ salvando: false });
        toast.error(mensagemErro(e, 'Não foi possível salvar a linha.'));
      });
  };

  // Exporta o que a tabela mostra (busca aplicada), no layout da planilha.
  // Exporta o que a tabela mostra (busca aplicada): uma linha por conta, com
  // CPF, Conta, Valor e Descrição lado a lado: profissional 4.1.5 (já com a
  // 2ª via) e empresa 2.1.3.2. Valor zero não sai (estagiário só tem a linha
  // da empresa).
  exportar = () => {
    const { itens, competencia, pedido } = this.state;
    const visiveis = this.copia.linhas();
    const base = visiveis.length ? visiveis : itens;
    const COLUNAS = ['CPF', 'Conta', 'Valor', 'Descrição', 'Lançamento', 'Nome', 'Cartão'];
    const linhas = [];
    base.forEach((l) => {
      [['valor_profissional', '4.1.5', 'Profissional'], ['valor_empresa', '2.1.3.2', 'Empresa']].forEach(
        ([coluna, conta, rotulo]) => {
          const valor = numero(l[coluna]);
          if (Math.abs(valor) < 0.005) return;
          linhas.push({
            CPF: l.cpf_funcionario,
            Conta: conta,
            Valor: valor,
            Descrição: descricaoVA(l.operadora, l.tipo),
            Lançamento: rotulo,
            Nome: l.nome_funcionario,
            Cartão: rotuloCartao(l.operadora, l.tipo)
          });
        }
      );
    });

    const total = Math.round(linhas.reduce((s, x) => s + x.Valor, 0) * 100) / 100;
    const ws = XLSX.utils.json_to_sheet(linhas.concat([{ CPF: 'TOTAL', Valor: total }]), { header: COLUNAS });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, `${rotuloCompetencia(competencia).replace('/', '-')}_ALIM_REF`);
    XLSX.writeFile(
      wb,
      `Pedido_Alimentacao_Refeicao_${competencia}${pedido ? `_${pedido.dias_uteis}dias` : ''}.xlsx`
    );
  };

  colunas = () => [
    {
      Header: this.copia.cabecalho('Nome', 'nome_funcionario'),
      accessor: 'nome_funcionario',
      width: 260,
      Cell: (row) => (
        <span
          className="action-cell"
          style={{ color: '#2f6fa8', cursor: 'pointer' }}
          onClick={() => this.abrirEdicao(row.original)}
        >
          {row.value}
          {ehVerdadeiro(row.original.estagiario) ? (
            <span style={{ marginLeft: 8 }}>
              <Tag tone="blue" dot={false}>Estagiário</Tag>
            </span>
          ) : null}
          {ehVerdadeiro(row.original.dias_ajustado) ? (
            <span style={{ marginLeft: 8 }}>
              <Tag tone="orange" dot={false}>Ajustado</Tag>
            </span>
          ) : null}
        </span>
      )
    },
    this.copia.coluna('Projeto', 'projeto', { width: 100, formatar: (v) => v || '—' }),
    this.copia.coluna('Cartão', 'operadora', {
      width: 120,
      formatar: (v) => ROTULO_OPERADORA[v] || v || '—'
    }),
    {
      ...this.copia.coluna('Tipo', 'tipo', { width: 120 }),
      Cell: (row) =>
        (row.value || '').trim()
          ? ROTULO_TIPO[row.value.trim()] || row.value
          : row.original.operadora === 'ifood'
          ? 'Alim. e ref.'
          : '—'
    },
    this.copia.coluna('Valor/dia', 'valor_dia', { width: 110, formatar: dinheiro }),
    this.copia.coluna('Dias', 'dias_trabalhados', { width: 70 }),
    this.copia.coluna('Total mês', 'total_mes', { width: 130, formatar: dinheiro }),
    this.copia.coluna('2ª via', 'valor_segunda_via', { width: 110, formatar: dinheiro }),
    this.copia.coluna('Profissional (4.1.5)', 'valor_profissional', { width: 160, formatar: dinheiro }),
    this.copia.coluna('Empresa (2.1.3.2)', 'valor_empresa', { width: 150, formatar: dinheiro }),
    this.copia.coluna('Observação', 'observacao', { width: 240, formatar: (v) => v || '' })
  ];

  render() {
    const {
      competencia, diasUteis, feriados, pedido, foraDoPedido, itens, totais, porCartao,
      carregando, calculando, edicao, salvando
    } = this.state;

    const filtros = (
      <>
        {this.props.seletorPagina}
        <FilterSelect value={competencia} onChange={this.trocarCompetencia}>
          {competenciasOferecidas().map((c) => (
            <MenuItem key={c} value={c}>{rotuloCompetencia(c)}</MenuItem>
          ))}
        </FilterSelect>
      </>
    );

    const acoes = (
      <>
        <TextField
          label="Feriados (dias)"
          placeholder="12, 28"
          value={feriados}
          onChange={this.trocarFeriados}
          style={{ width: 130, marginRight: 8 }}
          helperText="seg–sex do mês"
        />
        <TextField
          label="Dias úteis"
          type="number"
          value={diasUteis}
          onChange={(e) => this.setState({ diasUteis: e.target.value })}
          inputProps={{ min: 0, max: 31 }}
          style={{ width: 100, marginRight: 8 }}
          helperText={`seg–sex: ${diasUteisDoMes(competencia, [])}`}
        />
        <DsButton intent="primary" disabled={calculando} onClick={this.calcular}>
          {calculando ? 'Calculando...' : pedido ? 'Recalcular para todos' : 'Calcular para todos'}
        </DsButton>
        <DsButton intent="outlined" disabled={itens.length === 0} onClick={this.exportar}>
          Exportar Excel
        </DsButton>
      </>
    );

    const resumo = [
      ['Total do pedido', totais.total_mes],
      ['Profissional (4.1.5)', totais.valor_profissional],
      ['Empresa (2.1.3.2)', totais.valor_empresa],
      ['2ª via', totais.valor_segunda_via]
    ].concat(
      porCartao.map((c) => [`${rotuloCartao(c.operadora, c.tipo)} (${c.pessoas})`, c.total_mes])
    );

    return (
      <div>
        <p style={{ color: '#666', margin: '12px 0 4px' }}>
          {pedido
            ? `Calculado com ${pedido.dias_uteis} dia(s) útil(eis) em ${String(pedido.dt_calculo).slice(8, 10)}/${String(pedido.dt_calculo).slice(5, 7)}${pedido.calculado_por_nome ? ` por ${pedido.calculado_por_nome}` : ''}. Clique no nome para ajustar dias, 2ª via ou observação.`
            : 'Pedido deste mês ainda não calculado. Informe os feriados (os dias úteis se ajustam) e clique em Calcular para todos.'}
        </p>
        {foraDoPedido > 0 ? (
          <p style={{ color: '#8a6d3b', margin: '0 0 8px' }}>
            {pedido
              ? `${foraDoPedido} pessoa(s) com vale-alimentação no cadastro ainda não estão neste pedido. Recalcule para incluir.`
              : `${foraDoPedido} pessoa(s) com vale-alimentação e cartão no cadastro entram no cálculo.`}
          </p>
        ) : null}

        {itens.length > 0 ? (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24, padding: '8px 0 12px' }}>
            {resumo.map(([titulo, valor]) => (
              <div key={titulo}>
                <div style={{ fontSize: 12, color: '#666' }}>{titulo}</div>
                <div style={{ fontSize: 16, fontWeight: 500 }}>{dinheiro(numero(valor))}</div>
              </div>
            ))}
          </div>
        ) : null}

        <DataTable
          actions={acoes}
          filters={filtros}
          data={itens}
          columns={this.colunas()}
          className="ds-table -highlight ds-table--scroll-x"
          getTableProps={this.copia.capturarLinhasVisiveis}
          loading={carregando}
          defaultPageSize={20}
          showSearch
          showTotal
          searchPlaceholder="Buscar por nome ou CPF"
          noDataText={pedido ? 'Ninguém neste pedido' : 'Pedido ainda não calculado'}
        />

        <Modal
          isOpen={!!edicao}
          onClose={this.fecharEdicao}
          title={edicao ? edicao.nome_funcionario : ''}
          maxWidth="sm"
          fullWidth
        >
          {edicao ? (
            <div>
              <p style={{ marginTop: 0, color: '#666' }}>
                {rotuloCartao(edicao.operadora, edicao.tipo)} · {dinheiro(edicao.valor_dia)} por dia
                {ehVerdadeiro(edicao.estagiario) ? ' · Estagiário: tudo da empresa' : ''}
              </p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
                <TextField
                  label="Dias"
                  type="number"
                  inputProps={{ min: 0, max: 31 }}
                  value={this.state.edDias}
                  onChange={(e) => this.setState({ edDias: e.target.value })}
                  helperText="Licença, falta etc."
                  style={{ width: 160 }}
                />
                <TextField
                  label="2ª via do cartão (R$)"
                  value={this.state.edSegunda}
                  onChange={(e) => this.setState({ edSegunda: e.target.value })}
                  helperText="Desconta do profissional"
                  style={{ width: 200 }}
                />
              </div>
              <TextField
                label="Observação"
                fullWidth
                value={this.state.edObs}
                onChange={(e) => this.setState({ edObs: e.target.value.slice(0, 255) })}
                style={{ marginTop: 16 }}
              />
              <p style={{ fontSize: 13, color: '#666' }}>
                Total {dinheiro(edicao.total_mes)} · Profissional {dinheiro(edicao.valor_profissional)} ·
                Empresa {dinheiro(edicao.valor_empresa)}
                {ehVerdadeiro(edicao.dias_ajustado)
                  ? ' · Dias ajustados à mão: o recálculo geral mantém.'
                  : ''}
              </p>
              <div style={{ marginTop: 16, display: 'flex', justifyContent: 'space-between' }}>
                <DsButton intent="text" disabled={salvando} onClick={this.recalcularLinha}>
                  Recalcular pelo cadastro
                </DsButton>
                <span>
                  <DsButton intent="text" onClick={this.fecharEdicao}>Cancelar</DsButton>
                  <DsButton intent="primary" disabled={salvando} onClick={this.salvarEdicao}>
                    {salvando ? 'Salvando...' : 'Salvar'}
                  </DsButton>
                </span>
              </div>
            </div>
          ) : null}
        </Modal>
      </div>
    );
  }
}

export default ValeAlimentacao;
